/**
 * JeriCommerce Pass API · staging
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 202609.19.01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AccessToken } from '../model/models';
import { BalancePreviewDto } from '../model/models';
import { CouponAssignDto } from '../model/models';
import { CustomerDto } from '../model/models';
import { ExecuteCustomEarningFlowDto } from '../model/models';
import { ExecuteCustomEarningFlowResponseDto } from '../model/models';
import { IncreaseBalanceDto } from '../model/models';
import { RewardRedeemDto } from '../model/models';
import { SendPush } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    CustomerActionsServiceInterface,
    CustomerActionsControllerAssignCouponV1RequestParams,
    CustomerActionsControllerDecreaseBalanceV1RequestParams,
    CustomerActionsControllerExecuteCustomEarningFlowV1RequestParams,
    CustomerActionsControllerGetCustomerByEmailV1RequestParams,
    CustomerActionsControllerGetCustomerTokenV1RequestParams,
    CustomerActionsControllerIncreaseBalanceV1RequestParams,
    CustomerActionsControllerPreviewBalanceExchangeV1RequestParams,
    CustomerActionsControllerRedeemRewardV1RequestParams,
    CustomerActionsControllerSendPushV1RequestParams
} from './customer-actions.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class CustomerActionsService implements CustomerActionsServiceInterface {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Assign a coupon
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerAssignCouponV1(requestParameters: CustomerActionsControllerAssignCouponV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public customerActionsControllerAssignCouponV1(requestParameters: CustomerActionsControllerAssignCouponV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public customerActionsControllerAssignCouponV1(requestParameters: CustomerActionsControllerAssignCouponV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public customerActionsControllerAssignCouponV1(requestParameters: CustomerActionsControllerAssignCouponV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const couponAssignDto = requestParameters.couponAssignDto;
        if (couponAssignDto === null || couponAssignDto === undefined) {
            throw new Error('Required parameter couponAssignDto was null or undefined when calling customerActionsControllerAssignCouponV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerAssignCouponV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupon/assign`,
            couponAssignDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Decrease balance
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerDecreaseBalanceV1(requestParameters: CustomerActionsControllerDecreaseBalanceV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public customerActionsControllerDecreaseBalanceV1(requestParameters: CustomerActionsControllerDecreaseBalanceV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public customerActionsControllerDecreaseBalanceV1(requestParameters: CustomerActionsControllerDecreaseBalanceV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public customerActionsControllerDecreaseBalanceV1(requestParameters: CustomerActionsControllerDecreaseBalanceV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const increaseBalanceDto = requestParameters.increaseBalanceDto;
        if (increaseBalanceDto === null || increaseBalanceDto === undefined) {
            throw new Error('Required parameter increaseBalanceDto was null or undefined when calling customerActionsControllerDecreaseBalanceV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerDecreaseBalanceV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/balance/decrease`,
            increaseBalanceDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Execute a custom earning flow for a customer
     * earningFlowId may be the program engagement flow UUID or its EngagementFlowType name (e.g. CUSTOM_1). Auth: an API key targets any customer via body customerEmail; a customer JWT executes the flow for the authenticated customer.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerExecuteCustomEarningFlowV1(requestParameters: CustomerActionsControllerExecuteCustomEarningFlowV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ExecuteCustomEarningFlowResponseDto>;
    public customerActionsControllerExecuteCustomEarningFlowV1(requestParameters: CustomerActionsControllerExecuteCustomEarningFlowV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ExecuteCustomEarningFlowResponseDto>>;
    public customerActionsControllerExecuteCustomEarningFlowV1(requestParameters: CustomerActionsControllerExecuteCustomEarningFlowV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ExecuteCustomEarningFlowResponseDto>>;
    public customerActionsControllerExecuteCustomEarningFlowV1(requestParameters: CustomerActionsControllerExecuteCustomEarningFlowV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const executeCustomEarningFlowDto = requestParameters.executeCustomEarningFlowDto;
        if (executeCustomEarningFlowDto === null || executeCustomEarningFlowDto === undefined) {
            throw new Error('Required parameter executeCustomEarningFlowDto was null or undefined when calling customerActionsControllerExecuteCustomEarningFlowV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerExecuteCustomEarningFlowV1.');
        }
        const earningFlowId = requestParameters.earningFlowId;
        if (earningFlowId === null || earningFlowId === undefined) {
            throw new Error('Required parameter earningFlowId was null or undefined when calling customerActionsControllerExecuteCustomEarningFlowV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<ExecuteCustomEarningFlowResponseDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/custom-earning-flows/${encodeURIComponent(String(earningFlowId))}/execute`,
            executeCustomEarningFlowDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get customer details by email
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerGetCustomerByEmailV1(requestParameters: CustomerActionsControllerGetCustomerByEmailV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerDto>;
    public customerActionsControllerGetCustomerByEmailV1(requestParameters: CustomerActionsControllerGetCustomerByEmailV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerDto>>;
    public customerActionsControllerGetCustomerByEmailV1(requestParameters: CustomerActionsControllerGetCustomerByEmailV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerDto>>;
    public customerActionsControllerGetCustomerByEmailV1(requestParameters: CustomerActionsControllerGetCustomerByEmailV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerGetCustomerByEmailV1.');
        }
        const email = requestParameters.email;
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling customerActionsControllerGetCustomerByEmailV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<CustomerDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/${encodeURIComponent(String(email))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a customer token
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerGetCustomerTokenV1(requestParameters: CustomerActionsControllerGetCustomerTokenV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<AccessToken>;
    public customerActionsControllerGetCustomerTokenV1(requestParameters: CustomerActionsControllerGetCustomerTokenV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<AccessToken>>;
    public customerActionsControllerGetCustomerTokenV1(requestParameters: CustomerActionsControllerGetCustomerTokenV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<AccessToken>>;
    public customerActionsControllerGetCustomerTokenV1(requestParameters: CustomerActionsControllerGetCustomerTokenV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const email = requestParameters.email;
        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling customerActionsControllerGetCustomerTokenV1.');
        }
        const tokenType = requestParameters.tokenType;
        if (tokenType === null || tokenType === undefined) {
            throw new Error('Required parameter tokenType was null or undefined when calling customerActionsControllerGetCustomerTokenV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerGetCustomerTokenV1.');
        }
        const expiresIn = requestParameters.expiresIn;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (email !== undefined && email !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>email, 'email');
        }
        if (tokenType !== undefined && tokenType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>tokenType, 'token_type');
        }
        if (expiresIn !== undefined && expiresIn !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>expiresIn, 'expires_in');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<AccessToken>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/customers/token`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Increase balance
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerIncreaseBalanceV1(requestParameters: CustomerActionsControllerIncreaseBalanceV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public customerActionsControllerIncreaseBalanceV1(requestParameters: CustomerActionsControllerIncreaseBalanceV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public customerActionsControllerIncreaseBalanceV1(requestParameters: CustomerActionsControllerIncreaseBalanceV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public customerActionsControllerIncreaseBalanceV1(requestParameters: CustomerActionsControllerIncreaseBalanceV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const increaseBalanceDto = requestParameters.increaseBalanceDto;
        if (increaseBalanceDto === null || increaseBalanceDto === undefined) {
            throw new Error('Required parameter increaseBalanceDto was null or undefined when calling customerActionsControllerIncreaseBalanceV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerIncreaseBalanceV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/balance/increase`,
            increaseBalanceDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerPreviewBalanceExchangeV1(requestParameters: CustomerActionsControllerPreviewBalanceExchangeV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<BalancePreviewDto>;
    public customerActionsControllerPreviewBalanceExchangeV1(requestParameters: CustomerActionsControllerPreviewBalanceExchangeV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<BalancePreviewDto>>;
    public customerActionsControllerPreviewBalanceExchangeV1(requestParameters: CustomerActionsControllerPreviewBalanceExchangeV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<BalancePreviewDto>>;
    public customerActionsControllerPreviewBalanceExchangeV1(requestParameters: CustomerActionsControllerPreviewBalanceExchangeV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const currency = requestParameters.currency;
        if (currency === null || currency === undefined) {
            throw new Error('Required parameter currency was null or undefined when calling customerActionsControllerPreviewBalanceExchangeV1.');
        }
        const amount = requestParameters.amount;
        if (amount === null || amount === undefined) {
            throw new Error('Required parameter amount was null or undefined when calling customerActionsControllerPreviewBalanceExchangeV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerPreviewBalanceExchangeV1.');
        }
        const customerEmail = requestParameters.customerEmail;
        const sourceName = requestParameters.sourceName;
        const locationId = requestParameters.locationId;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (currency !== undefined && currency !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>currency, 'currency');
        }
        if (amount !== undefined && amount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>amount, 'amount');
        }
        if (customerEmail !== undefined && customerEmail !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>customerEmail, 'customerEmail');
        }
        if (sourceName !== undefined && sourceName !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sourceName, 'sourceName');
        }
        if (locationId !== undefined && locationId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>locationId, 'locationId');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<BalancePreviewDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/balance-preview`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Redeem a reward
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerRedeemRewardV1(requestParameters: CustomerActionsControllerRedeemRewardV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public customerActionsControllerRedeemRewardV1(requestParameters: CustomerActionsControllerRedeemRewardV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public customerActionsControllerRedeemRewardV1(requestParameters: CustomerActionsControllerRedeemRewardV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public customerActionsControllerRedeemRewardV1(requestParameters: CustomerActionsControllerRedeemRewardV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const rewardRedeemDto = requestParameters.rewardRedeemDto;
        if (rewardRedeemDto === null || rewardRedeemDto === undefined) {
            throw new Error('Required parameter rewardRedeemDto was null or undefined when calling customerActionsControllerRedeemRewardV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerRedeemRewardV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/reward/redeem`,
            rewardRedeemDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send a push notification
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customerActionsControllerSendPushV1(requestParameters: CustomerActionsControllerSendPushV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public customerActionsControllerSendPushV1(requestParameters: CustomerActionsControllerSendPushV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public customerActionsControllerSendPushV1(requestParameters: CustomerActionsControllerSendPushV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public customerActionsControllerSendPushV1(requestParameters: CustomerActionsControllerSendPushV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const sendPush = requestParameters.sendPush;
        if (sendPush === null || sendPush === undefined) {
            throw new Error('Required parameter sendPush was null or undefined when calling customerActionsControllerSendPushV1.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling customerActionsControllerSendPushV1.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (api-key) required
        credential = this.configuration.lookupCredential('api-key');
        if (credential) {
            headers = headers.set('api-key', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/send-push`,
            sendPush,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
